import React, {useState} from 'react';
// import { UsersIcon, PaperClipIcon } from '@heroicons/react/solid'

//buttons
import ProjectsDropDown from '../buttons/ProjectsDropDown';

//dialogs
import AddTask from '../dialogs/AddTask';

//image
import defaultPng from '../../../../images/default.png'

const ProfileHeading = ({profile}) => {
  const [ openAddTask, setOpenAddTask ] = useState(false)

  return (
    <div>
      <div>
        <img 
        className="h-32 w-full object-cover lg:h-48" 
        src="https://images.unsplash.com/photo-1444628838545-ac4016a5418a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" 
        alt="background" 
        />
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
          <div className="flex">
            <img 
            className="h-24 w-24 rounded-full ring-4 ring-blue bg-white sm:h-32 sm:w-32" 
            //src='https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80' 
            src={defaultPng}
            alt="profile" 
            />
          </div>
          <div className="mt-6 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
            <div className="sm:hidden md:block mt-6 min-w-0 flex-1">
              <h1 className="text-2xl font-bold text-gray-900 truncate">{profile.firstName} {profile.lastName}</h1>
              <p className="text-sm font-medium text-gray-600">{profile.company}</p>
            </div>
            <div className="mt-6 flex justify-stretch space-y-3 sm:flex-row sm:space-y-0 ">
              {/* <button
                type="button"
                className="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
              >
                <UsersIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                <span>Contacts</span>
              </button> */}
              {/* <button
                type="button"
                className="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
                onClick={()=> setOpenAddTask(true) }
              >
                <PaperClipIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                <span>Add task</span>
              </button> */}
              <div className = 'ml-11'>
                <ProjectsDropDown />
              </div>
            </div>
          </div>
        </div>
        <div className="hidden sm:block md:hidden mt-6 min-w-0 flex-1">
          <h1 className="text-2xl font-bold text-gray-900 truncate">{profile.firstName} {profile.lastName}</h1>
        </div>
      </div>
      {openAddTask ? 
        <AddTask open={openAddTask} setOpen={setOpenAddTask}/> 
      : 
        null
      }
    </div>
  )
}

export default ProfileHeading